import ChatStore from "./ChatStore";
import { DateshipStore } from "./DateshipStore";
import { DumpStore } from "./DumpStore";
import { IMChatListStore } from "./IMChatListStore";
import MainStore from "./MainStore";
import { MatchStore } from "./MatchStore";
import { NotificationManagerStore } from "./NotificationManagerStore";
import { ProfileStore } from "./ProfileStore";
import RegistrationStore from "./RegistrationStore";
import UIStore from "./UIStore";

export class RootStore{

    mainStore: MainStore
    chatStore: ChatStore
    regStore: RegistrationStore
    uiStore: UIStore
    imChatListStore: IMChatListStore
    profileStore: ProfileStore
    dateshipStore: DateshipStore
    matchStore: MatchStore
    dumpStore: DumpStore
    notifManager: NotificationManagerStore

    constructor(){
        this.mainStore = new MainStore(this)
        this.chatStore = new ChatStore()
        this.regStore = new RegistrationStore()
        this.uiStore = new UIStore(this)
        this.imChatListStore = new IMChatListStore(this)
        this.profileStore = new ProfileStore()
        this.dateshipStore = new DateshipStore()
        this.matchStore = new MatchStore()
        this.notifManager = new NotificationManagerStore()
        this.dumpStore = new DumpStore()


    }

    logout(){
        this.mainStore.logoutUser()
        this.mainStore = new MainStore(this)
        this.chatStore = new ChatStore()
        this.regStore = new RegistrationStore()
        //this.uiStore = new UIStore(this)
        this.imChatListStore = new IMChatListStore(this)
        this.profileStore = new ProfileStore()
        this.dateshipStore = new DateshipStore()
        this.matchStore = new MatchStore()
        this.notifManager = new NotificationManagerStore()
    }

}